import getLabel from './labels';
import colorRanges from "./colorRanges";

class LinkagesDataLayerService {
    apiEndBaseUrl = import.meta.env.VITE_BASE_URL_RENDA_IBGE;
    apiKey = import.meta.env.VITE_RENDA_IBGE_API_KEY;

    getDataLayer = async (requestPayload) => {

        if (requestPayload?.field?.includes("|")) {
            const [layer, property] = requestPayload.field.split("|");
            requestPayload.camada = layer;
            requestPayload.field = property;
        }

        const camadasRendaEConsumo = ['renda', 'consumo_valor', 'consumo_porcentagem'];

        if (camadasRendaEConsumo.includes(requestPayload.camada)) {
            requestPayload.camada = 'renda_consumo';
        }

        if (requestPayload.camada === 'populacao' || requestPayload.camada === 'domicilios') {
            requestPayload.camada = 'populacao_domicilios';
        }


        return axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer`, requestPayload, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getRequiredPermissionsMap = () => {
        return {
            'renda': 'renda',
            'consumo_valor': 'consumo',
            'consumo_porcentagem': 'consumo',
            'trabalhador': 'trabalhador',
            'populacao': 'populacao',
            'domicilios': 'domicilios',
            'expansao_urbana': 'expansao_urbana',
            'area_urbanizada': 'area_urbanizada',
            'vazios_urbanos': 'vazios_urbanos',
            'dutovias': 'dutovias',
            'area_preservacao': 'area_preservacao',
        }
    }

    getAvailableLayers = () => {
        return [
            {
                group: 'Econômico',
                options: [
                    { value: 'renda', label: 'Renda' },
                    { value: 'consumo_valor', label: 'Consumo (R$)' },
                    { value: 'consumo_porcentagem', label: 'Consumo (%)' },
                    { value: 'trabalhador', label: 'Trabalhador' },
                ]
            },
            {
                group: 'Demográfico',
                options: [
                    { value: 'populacao', label: 'População' },
                    { value: 'domicilios', label: 'Domicílios' },
                ]
            },
            {
                group: 'Urbanistico',
                options: [
                    { value: 'expansao_urbana', label: 'Expansão Urbana' },
                    { value: 'area_urbanizada', label: 'Área Urbanizada' },
                    { value: 'vazios_urbanos', label: 'Vazios Urbanos' },
                    { value: 'dutovias', label: 'Dutovias' },
                ]
            },
            {
                group: 'Ambientais',
                options: [
                    { value: 'area_preservacao', label: 'Área Preservacao' },
                ]
            }
        ];
    }

    getLayerLabel = (layerName) => {
        const layersAnGroups = this.getAvailableLayers();

        const layers = layersAnGroups.reduce((acc, group) => {
            return acc.concat(group.options);
        }, []);

        const layer = layers.find(l => l.value === layerName);
        return layer ? layer.label : layerName;
    }

    getPropertiesForColorMap = (layerName) => {
        const properties = {
            'renda': {
                properties: [
                    "renda|rend_mensal_por_domicilio2025",
                    "renda|nr_salario_minimo_mensal_por_domicilio",
                    "indicadores_municipio|pib_per_capita",
                    "indicadores_municipio|pib",
                ]
            },
            'consumo_valor': {
                properties: [
                    "consumo_valor|vl_despesas_consumo",
                    "consumo_valor|vl_alimentacao_fora",
                    "consumo_valor|vl_alimentacao_dentro",
                    "consumo_valor|vl_habitacao",
                    "consumo_valor|vl_recreacao_e_cultura",
                    "consumo_valor|vl_material_construcao",
                    "consumo_valor|vl_artigos_limpeza",
                    "consumo_valor|vl_mobiliarios_artigos_lar",
                    "consumo_valor|vl_eletrodomesticos",
                    "consumo_valor|vl_vestuario",
                    "consumo_valor|vl_calcados",
                    "consumo_valor|vl_despesas_viagens",
                    "consumo_valor|vl_higiene_cuidados_pessoais",
                    "consumo_valor|vl_matriculas_mensalidades",
                    "consumo_valor|vl_livros_material_escolar",
                    "consumo_valor|vl_gastos_medicamentos",
                    "consumo_valor|vl_outras_despesas_saude",
                    "consumo_valor|total_despesas_consumo",
                    "consumo_valor|total_alimentacao_fora",
                    "consumo_valor|total_alimentacao_dentro",
                    "consumo_valor|total_habitacao",
                    "consumo_valor|total_material_construcao",
                    "consumo_valor|total_artigos_limpeza",
                    "consumo_valor|total_mobiliarios_artigos_lar",
                    "consumo_valor|total_eletrodomesticos",
                    "consumo_valor|total_vestuario",
                    "consumo_valor|total_calcados",
                    "consumo_valor|total_despesas_viagens",
                    "consumo_valor|total_higiene_cuidados_pessoais",
                    "consumo_valor|total_matriculas_mensalidades",
                    "consumo_valor|total_livros_material_escolar",
                    "consumo_valor|total_gastos_medicamentos",
                    "consumo_valor|total_outras_despesas_saude",
                    "consumo_valor|total_recreacao_e_cultura",
                    "consumo_valor|vl_investimento_em_imovel",
                    "consumo_valor|total_investimento_em_imovel",
                    "consumo_valor|vl_acessorios_de_moda",
                    "consumo_valor|total_acessorios_de_moda",
                    "consumo_valor|total_servicos_pessoais",
                    "consumo_valor|vl_servicos_pessoais",
                    "consumo_valor|vl_educacao",
                    "consumo_valor|total_educacao",
                    "consumo_valor|vl_saude",
                    "consumo_valor|total_saude",
                    "consumo_valor|vl_alimentacao_bebidas",
                    "consumo_valor|total_alimentacao_bebidas",
                ]
            }
            , 'consumo_porcentagem': {
                properties: [
                    "consumo_porcentagem|tx_alimentacao_dentro",
                    "consumo_porcentagem|tx_alimentacao_fora",
                    "consumo_porcentagem|tx_artigos_limpeza",
                    "consumo_porcentagem|tx_calcados",
                    "consumo_porcentagem|tx_despesas_consumo",
                    "consumo_porcentagem|tx_despesas_viagens",
                    "consumo_porcentagem|tx_eletrodomesticos",
                    "consumo_porcentagem|tx_gastos_medicamentos",
                    "consumo_porcentagem|tx_habitacao",
                    "consumo_porcentagem|tx_higiene_cuidados_pessoais",
                    "consumo_porcentagem|tx_livros_material_escolar",
                    "consumo_porcentagem|tx_material_construcao",
                    "consumo_porcentagem|tx_matriculas_mensalidades",
                    "consumo_porcentagem|tx_mobiliarios_artigos_lar",
                    "consumo_porcentagem|tx_outras_despesas_saude",
                    "consumo_porcentagem|tx_recreacao_e_cultura",
                    "consumo_porcentagem|tx_vestuario",
                    "consumo_porcentagem|tx_investimento_em_imovel",
                    "consumo_porcentagem|tx_acessorios_de_moda",
                    "consumo_porcentagem|tx_servicos_pessoais",
                    "consumo_porcentagem|tx_educacao",
                    "consumo_porcentagem|tx_saude",
                    "consumo_porcentagem|tx_alimentacao_bebidas",
                ]
            },
            'domicilios': {
                properties: [
                    'domicilios|nr_domicilios_particulares_v0003',
                    'domicilios|nr_domicilios_particulares_ocupados_v0007',
                    'domicilios|nr_domicilios_particulares_vagos',
                    'domicilios|nr_dom_part_perm_ocupados_casa_v00047',
                    'domicilios|nr_dom_part_perm_ocupados_vila_cond_v00048',
                    'domicilios|nr_dom_part_perm_ocupados_apartamento_v00049',
                    'indice_propriedade|tx_indice_propriedade',
                    'indice_propriedade|domic_part_proprio_quitado_v006',
                    'indice_propriedade|domic_part_proprio_em_aquisicao_v007',
                    'indice_propriedade|domic_part_alugado_v008',
                    'indice_propriedade|domic_part_cedido_por_empregador_v009',
                    'indice_propriedade|domic_part_cedido_outro_v010',
                    'indice_propriedade|domic_part_outra_condicao_v011',
                    'domicilios|indice_verticalizacao'
                ]
            },
            'populacao': {
                properties: [
                    'populacao|nr_pessoas_2022_v0001',
                    'populacao|nr_pessoas_proj_2025',
                    'populacao|nr_populacao_0_4_anos_v01031',
                    'populacao|nr_populacao_5_9_anos_v01032',
                    'populacao|nr_populacao_10_14_anos_v01033',
                    'populacao|nr_populacao_15_19_anos_v01034',
                    'populacao|nr_populacao_20_24_anos_v01035',
                    'populacao|nr_populacao_25_29_anos_v01036',
                    'populacao|nr_populacao_30_39_anos_v01037',
                    'populacao|nr_populacao_40_49_anos_v01038',
                    'populacao|nr_populacao_50_59_anos_v01039',
                    'populacao|nr_populacao_60_69_anos_v01040',
                    'populacao|nr_populacao_70_anos_mais_v01041',
                    'populacao|nr_densidade_demografica_hab_km2',
                    'populacao|tx_pessoas_domicilios',
                    'indicadores_municipio|idhm',
                ]
            }

        }

        return properties[layerName]?.properties;
    }

    removerAcentos = (texto) => {

        if (!texto) return texto;

        return texto
            .normalize("NFD")                 // separa letras dos diacríticos
            .replace(/[\u0300-\u036f]/g, "")  // remove os diacríticos
            .toLowerCase();                   // opcional: ignora maiúsculas
    }

    getOptionsForColorMap = (layerName) => {
        const properties = this.getPropertiesForColorMap(layerName);

        if (!properties) return [];

        let options = properties.map(property => {
            const labelProperty = property.split('|')[1];
            return { value: property, label: getLabel(labelProperty) }
        });

        if (layerName !== 'populacao') {
            options = options.sort((a, b) => {
                const labelA = this.removerAcentos(a.label);
                const labelB = this.removerAcentos(b.label);

                if (labelA < labelB) return -1;
                if (labelA > labelB) return 1;
                return 0;
            });
        }

        return options;
    }

    getColorRangerForDatalayerProperty = (layerName, property) => {

        if (property?.includes("|")) {
            property = property.split("|")[1];
        }

        const specificColorRange = colorRanges.colorsRange[layerName]?.[property];

        if (specificColorRange) {
            return specificColorRange;
        }

        const defaultColorRange = colorRanges.colorsRange[layerName]?.default;

        if (defaultColorRange) {
            return defaultColorRange;
        }

        return [];
    }

    getColorsOptions(datalayerName) {
        return colorRanges.colorsRange[datalayerName].colors_options;
    }


    /**
     * Busca os anos disponíveis para as informações que dependem do ano (ex: Trabalhador, Expansão Urbana.)
     * @param requestPayload
     * @returns {*}
     */
    getYearsForDataLayer = (requestPayload) => {
        return axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-year-options`, requestPayload, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    /**
     * Retorna o dicionário de dados da Linkages
     */
    getDataDictionary = () => {
        return axios.get(`${this.apiEndBaseUrl}/api/linkage/dicionario`, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getProjecaoDomicilios = async (requestPayload) => {
        return axios.post(`${this.apiEndBaseUrl}/api/linkage/projecao-domicilios`, {
            ...requestPayload,
            camada: 'projecao_domicilios',
        }, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getCrescimentoDomicilios = async (requestPayload) => {
        return axios.post(`${this.apiEndBaseUrl}/api/linkage/crescimento-domicilios`, {
            ...requestPayload,
            camada: 'crescimento_domicilios',
        }, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getDomiciliosFaixaRenda = async (requestPayload) => {
        return axios.post(`${this.apiEndBaseUrl}/api/linkage/domicilios-faixa-renda`, {
            ...requestPayload,
            camada: 'domicilios_faixa_renda',
        }, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getNumeroMoradores = async (requestPayload) => {
        return axios.post(`${this.apiEndBaseUrl}/api/linkage/domicilios-numero-moradores`, {
            ...requestPayload,
            camada: 'domicilios_numero_moradores',
        }, {
            headers: {
                'x-api-key': this.apiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getAggregatedData = async (requestPayload) => {

        const camadasRendaEConsumo = ['consumo_valor', 'consumo_porcentagem'];

        const headers = {
            'x-api-key': this.apiKey,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };

        if (requestPayload.camada === 'renda') {
            const [resIndicadores, resRenda] = await Promise.all([
                axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-aggregated`, { ...requestPayload, camada: 'indicadores_municipio' }, { headers }),
                axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-aggregated`, requestPayload, { headers }),
            ]);

            const SALARIO_MINIMO = 1621.00;

            const dataUnificada = resRenda.data.map((item, index) => {
                const merged = { ...item, ...(resIndicadores.data[index] ?? {}) };
                const renda = parseFloat(merged.renda_media_domiciliar);
                merged.nr_salario_minimo_mensal_por_domicilio = !isNaN(renda) ? renda / SALARIO_MINIMO : null;
                return merged;
            });

            return { data: dataUnificada, status: 200 };
        }

        if (camadasRendaEConsumo.includes(requestPayload.camada)) {
            requestPayload.camada = 'renda_consumo';
        }

        //para trazer todos os dados de domicilios
        //é preciso recuperar as informações de indice de propriedade também
        if (requestPayload.camada === "domicilios") {
            const payloadIndice = { ...requestPayload, camada: 'indice_propriedade' };

            const [resDomicilios, resIndice] = await Promise.all([
                axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-aggregated`, requestPayload, { headers }),
                axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-aggregated`, payloadIndice, { headers })
            ]);

            try {
                const dataUnificada = resDomicilios.data.map((item, index) => {
                    return {
                        ...item,
                        ...resIndice.data[index]
                    };
                });

                delete dataUnificada[0]['total'];

                return { data: dataUnificada, status: 200 };
            } catch (error) {
                throw error;
            }

        }

        return axios.post(`${this.apiEndBaseUrl}/api/linkage/data-layer-aggregated`, requestPayload, { headers });

    }
}

export default new LinkagesDataLayerService();
